var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "295px",
    height: "355px",
    viewBox: "0 0 295 355",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CLOUD STRUKT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.546,88.33 C44.77,88.33 38.5385,87.241 32.8515,85.063 C27.1645,82.885 22.2438333,79.8398333 18.0895,75.9275 C13.9351667,72.0151667 10.7286667,67.3566667 8.47,61.952 C6.21133333,56.5473333 5.082,50.6183333 5.082,44.165 C5.082,37.7116667 6.2315,31.7826667 8.5305,26.378 C10.8295,20.9733333 14.0763333,16.3148333 18.271,12.4025 C22.4656667,8.49016667 27.4468333,5.445 33.2145,3.267 C38.9821667,1.089 45.3346667,0 52.272,0 C56.2246667,0 60.1168333,0.463833333 63.9485,1.3915 C67.7801667,2.31916667 71.4101667,3.73083333 74.8385,5.6265 C78.2668333,7.52216667 81.3926667,9.922 84.216,12.826 L68.607,31.097 C67.4776667,29.7256667 66.1265,28.4753333 64.5535,27.346 C62.9805,26.2166667 61.1655,25.3091667 59.1085,24.6235 C57.0515,23.9378333 54.692,23.595 52.03,23.595 C49.2873333,23.595 46.6858333,24.0588333 44.2255,24.9865 C41.7651667,25.9141667 39.6275,27.2653333 37.8125,29.04 C35.9975,30.8146667 34.5656667,32.9926667 33.517,35.574 C32.4683333,38.1553333 31.944,41.14 31.944,44.528 C31.944,47.5933333 32.4683333,50.3763333 33.517,52.877 C34.5656667,55.3776667 36.058,57.5153333 37.994,59.29 C39.93,61.0646667 42.2693333,62.436 45.012,63.404 C47.7546667,64.372 50.82,64.856 54.208,64.856 C56.628,64.856 58.927,64.493 61.105,63.767 C63.283,63.041 65.2593333,62.0931667 67.034,60.9235 C68.8086667,59.7538333 70.3413333,58.443 71.632,56.991 L84.095,76.593 C81.9976667,78.8516667 79.2146667,80.8683333 75.746,82.643 C72.2773333,84.4176667 68.4456667,85.8091667 64.251,86.8175 C60.0563333,87.8258333 55.8213333,88.33 51.546,88.33 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-27.2%",
    y: "-28.9%",
    width: "154.8%",
    height: "148.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "95.227 87.12 95.227 2.42 121.363 2.42 121.363 64.856 157.663 64.856 157.663 87.12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-34.4%",
    y: "-30.1%",
    width: "168.9%",
    height: "150.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.241,88.33 C201.545667,88.33 195.415,87.241 189.849,85.063 C184.283,82.885 179.443,79.8196667 175.329,75.867 C171.215,71.9143333 168.048833,67.2356667 165.8305,61.831 C163.612167,56.4263333 162.503,50.5376667 162.503,44.165 C162.503,37.7116667 163.612167,31.8028333 165.8305,26.4385 C168.048833,21.0741667 171.215,16.4156667 175.329,12.463 C179.443,8.51033333 184.283,5.445 189.849,3.267 C195.415,1.089 201.505333,0 208.12,0 C214.815333,0 220.925833,1.089 226.4515,3.267 C231.977167,5.445 236.797,8.51033333 240.911,12.463 C245.025,16.4156667 248.191167,21.0741667 250.4095,26.4385 C252.627833,31.8028333 253.737,37.6713333 253.737,44.044 C253.737,50.4973333 252.627833,56.4263333 250.4095,61.831 C248.191167,67.2356667 245.025,71.9143333 240.911,75.867 C236.797,79.8196667 231.977167,82.885 226.4515,85.063 C220.925833,87.241 214.855667,88.33 208.241,88.33 Z M208.12,64.13 C210.862667,64.13 213.3835,63.646 215.6825,62.678 C217.9815,61.71 219.998167,60.3185 221.7325,58.5035 C223.466833,56.6885 224.797833,54.571 225.7255,52.151 C226.653167,49.731 227.117,47.069 227.117,44.165 C227.117,41.261 226.653167,38.599 225.7255,36.179 C224.797833,33.759 223.466833,31.6415 221.7325,29.8265 C219.998167,28.0115 217.9815,26.62 215.6825,25.652 C213.3835,24.684 210.862667,24.2 208.12,24.2 C205.377333,24.2 202.8565,24.684 200.5575,25.652 C198.2585,26.62 196.241833,28.0115 194.5075,29.8265 C192.773167,31.6415 191.442167,33.759 190.5145,36.179 C189.586833,38.599 189.123,41.261 189.123,44.165 C189.123,47.069 189.586833,49.731 190.5145,52.151 C191.442167,54.571 192.773167,56.6885 194.5075,58.5035 C196.241833,60.3185 198.2585,61.71 200.5575,62.678 C202.8565,63.646 205.377333,64.13 208.12,64.13 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-23.6%",
    y: "-28.9%",
    width: "147.1%",
    height: "148.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.674,167.846 C40.3333333,167.846 33.8195,166.414167 28.1325,163.5505 C22.4455,160.686833 17.9886667,156.754333 14.762,151.753 C11.5353333,146.751667 9.922,141.024333 9.922,134.571 L9.922,82.42 L36.3,82.42 L36.3,133.482 C36.3,135.821333 36.784,137.8985 37.752,139.7135 C38.72,141.5285 40.0711667,142.960333 41.8055,144.009 C43.5398333,145.057667 45.496,145.582 47.674,145.582 C50.0133333,145.582 52.0703333,145.057667 53.845,144.009 C55.6196667,142.960333 57.0313333,141.5285 58.08,139.7135 C59.1286667,137.8985 59.653,135.821333 59.653,133.482 L59.653,82.42 L85.426,82.42 L85.426,134.571 C85.426,141.024333 83.8126667,146.751667 80.586,151.753 C77.3593333,156.754333 72.9025,160.686833 67.2155,163.5505 C61.5285,166.414167 55.0146667,167.846 47.674,167.846 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-28.5%",
    y: "-29.9%",
    width: "157.0%",
    height: "150.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.786,167.12 L104.786,82.42 L142.054,82.42 C148.426667,82.42 154.275,83.4686667 159.599,85.566 C164.923,87.6633333 169.561333,90.5875 173.514,94.3385 C177.466667,98.0895 180.511833,102.546333 182.6495,107.709 C184.787167,112.871667 185.856,118.558667 185.856,124.77 C185.856,130.900667 184.787167,136.5675 182.6495,141.7705 C180.511833,146.9735 177.466667,151.4505 173.514,155.2015 C169.561333,158.9525 164.923,161.876667 159.599,163.974 C154.275,166.071333 148.426667,167.12 142.054,167.12 L104.786,167.12 Z M130.922,151.027 L126.445,144.856 L141.449,144.856 C144.111,144.856 146.531,144.351833 148.709,143.3435 C150.887,142.335167 152.782667,140.943667 154.396,139.169 C156.009333,137.394333 157.259667,135.276833 158.147,132.8165 C159.034333,130.356167 159.478,127.674 159.478,124.77 C159.478,121.866 159.034333,119.183833 158.147,116.7235 C157.259667,114.263167 156.009333,112.145667 154.396,110.371 C152.782667,108.596333 150.887,107.204833 148.709,106.1965 C146.531,105.188167 144.111,104.684 141.449,104.684 L126.082,104.684 L130.922,98.755 L130.922,151.027 Z",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.5%",
    y: "-30.1%",
    width: "153.0%",
    height: "150.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.567,248.33 C33.1943333,248.33 27.5678333,247.624167 22.6875,246.2125 C17.8071667,244.800833 13.5318333,242.804333 9.8615,240.223 C6.19116667,237.641667 2.904,234.616667 0,231.148 L15.125,214.208 C19.1583333,219.370667 23.3731667,222.778833 27.7695,224.4325 C32.1658333,226.086167 36.3,226.913 40.172,226.913 C41.7046667,226.913 43.076,226.771833 44.286,226.4895 C45.496,226.207167 46.4236667,225.743333 47.069,225.098 C47.7143333,224.452667 48.037,223.565333 48.037,222.436 C48.037,221.387333 47.6941667,220.5 47.0085,219.774 C46.3228333,219.048 45.4153333,218.422833 44.286,217.8985 C43.1566667,217.374167 41.9265,216.9305 40.5955,216.5675 C39.2645,216.2045 37.9738333,215.902 36.7235,215.66 C35.4731667,215.418 34.364,215.176 33.396,214.934 C28.556,213.804667 24.321,212.433333 20.691,210.82 C17.061,209.206667 14.036,207.270667 11.616,205.012 C9.196,202.753333 7.40116667,200.172 6.2315,197.268 C5.06183333,194.364 4.477,191.097 4.477,187.467 C4.477,183.353 5.42483333,179.602 7.3205,176.214 C9.21616667,172.826 11.7571667,169.922 14.9435,167.502 C18.1298333,165.082 21.7598333,163.226667 25.8335,161.936 C29.9071667,160.645333 34.122,160 38.478,160 C44.8506667,160 50.1746667,160.584833 54.45,161.7545 C58.7253333,162.924167 62.315,164.598 65.219,166.776 C68.123,168.954 70.6236667,171.495 72.721,174.399 L57.475,189.04 C55.7003333,187.346 53.845,185.9545 51.909,184.8655 C49.973,183.7765 47.9765,182.969833 45.9195,182.4455 C43.8625,181.921167 41.8256667,181.659 39.809,181.659 C37.9536667,181.659 36.3806667,181.800167 35.09,182.0825 C33.7993333,182.364833 32.791,182.8085 32.065,183.4135 C31.339,184.0185 30.976,184.845333 30.976,185.894 C30.976,186.942667 31.4398333,187.809833 32.3675,188.4955 C33.2951667,189.181167 34.4648333,189.766 35.8765,190.25 C37.2881667,190.734 38.6998333,191.117167 40.1115,191.3995 C41.5231667,191.681833 42.713,191.903667 43.681,192.065 C48.1176667,192.871667 52.1913333,193.980833 55.902,195.3925 C59.6126667,196.804167 62.8595,198.578833 65.6425,200.7165 C68.4255,202.854167 70.5631667,205.516167 72.0555,208.7025 C73.5478333,211.888833 74.294,215.66 74.294,220.016 C74.294,226.227333 72.7411667,231.430333 69.6355,235.625 C66.5298333,239.819667 62.3553333,242.985833 57.112,245.1235 C51.8686667,247.261167 46.0203333,248.33 39.567,248.33 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.4%",
    y: "-28.9%",
    width: "158.3%",
    height: "148.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "107.569 247.12 107.569 184.684 81.433 184.684 81.433 162.42 160.567 162.42 160.567 184.684 133.705 184.684 133.705 247.12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-27.2%",
    y: "-30.1%",
    width: "154.3%",
    height: "150.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.877,247.12 L173.877,162.42 L213.565,162.42 C219.453667,162.42 224.697,163.589667 229.295,165.929 C233.893,168.268333 237.482667,171.454667 240.064,175.488 C242.645333,179.521333 243.936,184.159667 243.936,189.403 C243.936,195.291667 242.645333,200.454333 240.064,204.891 C237.482667,209.327667 233.893,212.776167 229.295,215.2365 C224.697,217.696833 219.453667,218.927 213.565,218.927 L198.319,218.927 L198.319,247.12 L173.877,247.12 Z M218.284,247.12 L196.746,208.884 L223.487,205.859 L247.445,247.12 L218.284,247.12 Z M198.319,200.777 L209.451,200.777 C211.467667,200.777 213.1415,200.393833 214.4725,199.6275 C215.8035,198.861167 216.811833,197.792333 217.4975,196.421 C218.183167,195.049667 218.526,193.396 218.526,191.46 C218.526,189.685333 218.183167,188.172833 217.4975,186.9225 C216.811833,185.672167 215.763167,184.704167 214.3515,184.0185 C212.939833,183.332833 211.145,182.99 208.967,182.99 L198.319,182.99 L198.319,200.777 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-29.2%",
    y: "-30.1%",
    width: "159.4%",
    height: "150.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.674,327.846 C40.3333333,327.846 33.8195,326.414167 28.1325,323.5505 C22.4455,320.686833 17.9886667,316.754333 14.762,311.753 C11.5353333,306.751667 9.922,301.024333 9.922,294.571 L9.922,242.42 L36.3,242.42 L36.3,293.482 C36.3,295.821333 36.784,297.8985 37.752,299.7135 C38.72,301.5285 40.0711667,302.960333 41.8055,304.009 C43.5398333,305.057667 45.496,305.582 47.674,305.582 C50.0133333,305.582 52.0703333,305.057667 53.845,304.009 C55.6196667,302.960333 57.0313333,301.5285 58.08,299.7135 C59.1286667,297.8985 59.653,295.821333 59.653,293.482 L59.653,242.42 L85.426,242.42 L85.426,294.571 C85.426,301.024333 83.8126667,306.751667 80.586,311.753 C77.3593333,316.754333 72.9025,320.686833 67.2155,323.5505 C61.5285,326.414167 55.0146667,327.846 47.674,327.846 Z",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-28.5%",
    y: "-29.9%",
    width: "157.0%",
    height: "150.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-18"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.936,303.041 L114.103,283.681 L154.396,242.42 L184.041,242.42 L122.936,303.041 Z M104.786,327.12 L104.786,242.42 L130.922,242.42 L130.922,327.12 L104.786,327.12 Z M157.905,327.12 L127.171,287.069 L144.111,272.428 L187.55,327.12 L157.905,327.12 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-26.0%",
    y: "-30.1%",
    width: "153.2%",
    height: "150.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-20"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-21",
    points: "214.896 327.12 214.896 264.684 188.76 264.684 188.76 242.42 267.894 242.42 267.894 264.684 241.032 264.684 241.032 327.12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-27.2%",
    y: "-30.1%",
    width: "154.3%",
    height: "150.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -4,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.270323427 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CLOUD-STRUKT",
    transform: "translate(13.758000, 17.880000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-9"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#64A40E",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#64A40E",
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-15"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#64A40E",
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-18)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#64A40E",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-20)",
    xlinkHref: "#path-19"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#64A40E",
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-22)",
    xlinkHref: "#path-21"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#64A40E",
    xlinkHref: "#path-21"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.55595a466e17a34ae7d44b95dec7db91.svg";
export { ForwardRef as ReactComponent };